import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Select,
  MenuItem,
  Checkbox,
  Grid,
  Typography,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useParams } from "react-router-dom";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
  useLazyTutorCsvQuery,
} from "../../services/tutor";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { successToast, errorToast } from "../../helpers";
import Loader from "../../helpers/Loader";
import WarnModal from "../../components/modals/WarnModal";
import Pagination from "../../components/Pagination";
import { usePutTutorProfileMutation } from "../../services/tutor";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validation";
import { useLazyGetClassDetailsQuery } from "../../services/class";
import {
  APP_ROLE,
  CLASS_MODE,
  CONTENT_TYPE,
} from "../../helpers/constants/enums";

// Generate dummy data for classes
const generateDummyClasses = () => {
  const classTypes = ["Public", "Private"];
  const paymentTypes = ["Per Session", "Per Hour"];
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const times = ["Morning", "Afternoon", "Evening"];

  return Array.from({ length: 15 }, (_, i) => ({
    id: `class-${i + 1}`,
    numberOfClasses: Math.floor(Math.random() * 20) + 5,
    classType: classTypes[Math.floor(Math.random() * classTypes.length)],
    totalEnrollments: Math.floor(Math.random() * 50) + 10,
    enrollmentTrends: {
      week: Math.floor(Math.random() * 15) + 5,
      month: Math.floor(Math.random() * 60) + 20,
      quarter: Math.floor(Math.random() * 180) + 60,
    },
    revenue: {
      total: Math.floor(Math.random() * 5000) + 1000,
      perStudent: Math.floor(Math.random() * 100) + 20,
    },
    paymentType: {
      perSession: Math.floor(Math.random() * 50) + 20,
      perHour: Math.floor(Math.random() * 30) + 15,
    },
    seatFillRate: `${Math.floor(Math.random() * 50) + 50}%`,
    mostBooked: {
      days: [...days]
        .sort(() => 0.5 - Math.random())
        .slice(0, 2)
        .join(", "),
      times: [...times]
        .sort(() => 0.5 - Math.random())
        .slice(0, 2)
        .join(", "),
    },
  }));
};

const Classes = () => {
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const navigate = useNavigate();
  const [rows, setRows] = useState<any>([]);
  const [dummyData] = useState(generateDummyClasses());
  const { _id } = useParams();
  const [allVideos] = useLazyGetClassDetailsQuery();
  const [totalCount, setTotalCount] = useState<number>(0);
  let totalPages = Math.ceil(totalCount / 10);
  const [totalEarning, setTotalEarning] = useState(0);

  const fetchVideos = async () => {
    try {
      // setIsLoading(true);
      const response = await allVideos({
        page: page,
        search: debouncedSearchTerm,
        tutorId: "685b9244cdfba1d4b76b790b",
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.classes?.data);
        setTotalCount(response?.data?.classes?.total);
      }
    } catch (error) {
      console.error(error);
    } finally {
      // setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchVideos();
  }, [page, debouncedSearchTerm]);
  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    // Filter data based on search term if needed
    let filteredData = dummyData;
    if (debouncedSearchTerm) {
      filteredData = dummyData.filter(
        (item) =>
          item.classType
            .toLowerCase()
            .includes(debouncedSearchTerm.toLowerCase())
        // item.paymentType
        //   ?.toLowerCase()
        //   .includes(debouncedSearchTerm.toLowerCase())
      );
    }

    // Paginate the data
    const startIndex = (page - 1) * 10;
    const paginatedData = filteredData.slice(startIndex, startIndex + 10);
    setRows(paginatedData);
    setTotalCount(filteredData.length);
  }, [page, debouncedSearchTerm, dummyData]);

  return (
    <div>
      <h2 className="mn_hdng" style={{ marginTop: 0 }}>
        Classes
      </h2>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography className="custom_label">
            Total Classes: {totalCount}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="custom_label">
            Total Earning: ${totalEarning}
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <Typography className="custom_label">
            Withdrawal Request: ${"withdrawalRequest"}
          </Typography> 
        </Grid> */}
        {/* <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', marginTop: '10px' }}>
                <Button variant="contained" color="primary" onClick={() => handleWithdrawStatus(2)} disabled={isUpdating}>
                  Accept
                </Button>
                <Button variant="contained" color="secondary" onClick={() => handleWithdrawStatus(3)} disabled={isUpdating}>
                  Reject
                </Button>
              </Grid> */}
      </Grid>
      <Box className="cards_header">
        {/* <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        /> */}
      </Box>

      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Class Name</TableCell>
              <TableCell align="center">Class Mode</TableCell>
              <TableCell align="center">Total Seats</TableCell>
              {/* <TableCell align="center">Enrollment trends</TableCell> */}
              <TableCell align="center">Fees</TableCell>
              {/* <TableCell align="center">Payment Type</TableCell> */}
              <TableCell align="center">Seat fill rate(%)</TableCell>
              {/* <TableCell align="center">Most booked(days/times)</TableCell> */}
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 ? (
              rows?.map((row: any, i: any) => (
                <TableRow key={row?.id}>
                  <TableCell align="center">
                    {(page - 1) * 10 + i + 1}
                  </TableCell>
                  <TableCell align="center">{row?.topic}</TableCell>
                  <TableCell align="center">
                    {CLASS_MODE[row?.classMode]}
                  </TableCell>
                  <TableCell align="center">{row?.seats}</TableCell>
                  {/* <TableCell align="center">
                    <p style={{ margin: 0 }}>
                      Week : {row.enrollmentTrends.week}
                    </p>
                    <p style={{ margin: 0 }}>
                      Month : {row.enrollmentTrends.month}
                    </p>
                    <p style={{ margin: 0 }}>
                      Quarter : {row.enrollmentTrends.quarter}
                    </p>
                  </TableCell> */}
                  <TableCell align="center">{row?.fees}</TableCell>
                  {/* <TableCell align="center">
                    <p style={{ margin: 0 }}>Total : ${row?.revenue?.total}</p>
                    <p style={{ margin: 0 }}>
                      Per Student : ${row?.revenue?.perStudent}
                    </p>
                  </TableCell> */}
                  {/* <TableCell align="center">
                    <p style={{ margin: 0 }}>
                      Per Session : ${row?.paymentType?.perSession}
                    </p>
                    <p style={{ margin: 0 }}>
                      Per Hour : ${row?.paymentType?.perHour}
                    </p>
                  </TableCell> */}
                  <TableCell align="center">
                    {Math.floor(row?.fillRate)}
                  </TableCell>
                  {/* <TableCell align="center">
                    <p style={{ margin: 0 }}>Days : {row?.mostBooked?.days}</p>
                    <p style={{ margin: 0 }}>
                      Times : {row?.mostBooked?.times}
                    </p>
                  </TableCell> */}
                  <TableCell>
                    <Box className="table_actions">
                      <IconButton
                        onClick={() =>
                          navigate(`/manage-classes/details/${row?._id}`, {
                            state: {
                              backRoute: `/manage-tutors/details/${_id}`,
                            },
                          })
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No class found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={handleChangePage}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Classes;
